import React from "react";

const Java_toLowerCase = () => {
  return (
    <div>
      <h1>Java toLowerCase</h1>
      <p>This page provides explanations, examples, and common use-cases for Java toLowerCase in Java.</p>
    </div>
  );
};

export default Java_toLowerCase;
